<template>
  <footer>
    <div class="footer-inner">
      <div class="footer-top">
        <div class="footer-brand">
          <div class="footer-logo">
            <img src="/img/logo.8db55515.png" alt="Kordelo logo" style="height:28px;width:auto;filter:brightness(0) invert(1);" />
            Kordelo
          </div>
          <p class="footer-tagline">{{ $t('footer.tagline') }}</p>
        </div>
      </div>
      <div class="footer-bottom">
        <span>{{ $t('footer.copy') }}</span>
        <div class="footer-bottom__links">
          <router-link to="/privacy">{{ $t('footer.privacy') }}</router-link>
          <span class="footer-bottom__sep">·</span>
          <router-link to="/terms">{{ $t('footer.terms') }}</router-link>
          <span class="footer-bottom__sep">·</span>
          <span>{{ $t('footer.credit') }} <a href="https://sidestudio.no" target="_blank" rel="noopener noreferrer">Sidestudio.no</a></span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'AppFooter',
  }
</script>

<style scoped>
footer {
  background: var(--text);
  color: rgba(255,255,255,0.65);
  padding: 3.5rem 2rem 2rem;
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.footer-top {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  padding-bottom: 2.5rem;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  margin-bottom: 2rem;
}

.footer-brand {}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.9rem;
}

.footer-tagline { font-size: 0.875rem; line-height: 1.65; max-width: 240px; }

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.8rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.footer-bottom__links {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-bottom__sep {
  opacity: 0.4;
}

.footer-bottom a, .footer-bottom__links a {
  color: rgba(255,255,255,0.65);
  text-decoration: none;
  transition: color 0.15s;
}

.footer-bottom a:hover, .footer-bottom__links a:hover {
  color: white;
}

@media (max-width: 900px) {
  .footer-top { grid-template-columns: 1fr; gap: 2.5rem; }
}
</style>
